export const OWNER_ROUTES = {
	DASHBOARD: "/dashboard",
	PROPERTIES: "/dashboard/properties",
	PROPERTY_NEW: "/dashboard/properties/new",
	PROPERTY_DETAIL: "/dashboard/properties/:id",
	PROPERTY_EDIT: "/dashboard/properties/:id/edit",
	PROPERTY_PRICING: "/dashboard/properties/:id/pricing",
	PROPERTY_LENGTH_DISCOUNTS: "/dashboard/properties/:id/length-discounts",
	BOOKINGS: "/dashboard/bookings",
	BOOKING_NEW: "/dashboard/bookings/new",
	BOOKING_DETAIL: "/dashboard/bookings/:id",
	CONTRACT_VIEW: "/dashboard/contracts/:id",
	CALENDAR: "/dashboard/calendar",
	TENANTS: "/dashboard/tenants",
	TENANT_DETAIL: "/dashboard/tenants/:id",
	CAUTIONS: "/dashboard/cautions",
	CAUTION_NEW: "/dashboard/cautions/new",
	CAUTION_DETAIL: "/dashboard/cautions/:id",
	TEMPLATES: "/dashboard/templates",
	TEMPLATE_NEW: "/dashboard/templates/new",
	TEMPLATE_EDIT: "/dashboard/templates/:id/edit",
	REVENUE: "/dashboard/revenue",
	SETTINGS: "/dashboard/settings",
} as const;
